export default {
  name: '404',
  template: require('./404.html')
};
